<script setup lang="ts">
import { computed, defineSlots, ref } from 'vue';
import ContextMenuButton from '@/dashboard/vue/components/common/ContextMenu/ContextMenuButton.vue';
import ArrowRight from '@/dashboard/vue/components/icons/ArrowRight.vue';
import { useMenuItem } from '@/dashboard/vue/components/common/Menu/useMenuItem';

const props = defineProps<{
  onlyLeft?: boolean;
  titleClass?: object;
  action?: () => void;
}>();

const slots = defineSlots<{
  default(props: object): unknown;

  menu(props: object): unknown;
}>();

const hasSubmenu = computed(() => !!slots.menu);
const { isSubmenuVisible, handleMouseEnter, submenuRef, positionClass } = useMenuItem(hasSubmenu.value, props.onlyLeft);
</script>

<template>
  <div class="relative flex w-full items-center" @mouseenter="handleMouseEnter">
    <ContextMenuButton :action="props.action" :need-dark="true" class="w-full" :class="{ 'pr-[30px]': hasSubmenu, ...titleClass }">
      <slot name="default"></slot>
    </ContextMenuButton>

    <ArrowRight v-if="hasSubmenu" class="absolute right-xs stroke-black dark:stroke-white" />

    <div v-if="isSubmenuVisible && hasSubmenu" ref="submenuRef" class="absolute top-[-6px]" :class="positionClass">
      <slot name="menu"></slot>
    </div>
  </div>
</template>
